module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment06-88bf7c9e05f935efd7fb3bedbd2ec01d.png";